import { useState, useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setUpdateDialog,
  resetUpdateForm,
  IssuedCards,
} from "../../../../app/slices/issuedCardSlice";
import { Controller, useForm } from "react-hook-form";
import { HiOutlineCreditCard, HiOutlineHashtag } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const IssuedOrderIdForm = ({ ids }) => {
  const [loading, setLoading] = useState(false);

  const _IssuedCard = useSelector((state) => state.issuedCard.issuedOrderId);

  const { control, reset, handleSubmit } = useForm({
    defaultValues: _IssuedCard.form,
  });

  const onSubmit = (data) => {
    setLoading(true);
    data.ids = ids;
    dispatch(IssuedCards.updateNumber(data))
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };
  useEffect(() => {
    reset({ ..._IssuedCard.form });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_IssuedCard.form]);

  useEffect(() => {
    return () => {
      dispatch(resetUpdateForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setUpdateDialog());
  };

  return (
    <FormDialog
      open={_IssuedCard.dialog}
      onClose={handleDialog}
      maxWidth="md"
      icon={<HiOutlineCreditCard />}
      title="تحديث رقم طلب الاصدار"
      subtitle="أدخل رقم طلب الاصدار للبطاقات المحددة ثم احفظ التغييرات"
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
      loading={_IssuedCard.loading}
    >
      <SectionCard icon={<HiOutlineHashtag />} title="معلومات الطلب">
        <Grid item xs={12}>
          <Controller
            name="order_issued_id"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="رقم الطلب الاصدار"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default IssuedOrderIdForm;
